import { combineEpics } from 'redux-observable';

import { createEmployeeEpic }                 from './CreateEmployee/CreateEmployeeEpic';
import { deleteEmployeeEpic }                 from './DeleteEmployee/DeleteEmployeeEpic';
import { findEmployeesEpic }                  from './FindEmployees/FindEmployeesEpic';
import { searchEmployeesEpic }                from './SearchEmployees/SearchEmployeesEpic';
import { findEmployeeEpic }                   from './FindEmployee/FindEmployeeEpic';
import { updateEmployeeEpic }                 from './UpdateEmployee/UpdateEmployeeEpic';


export const employeeEpics = combineEpics(
  createEmployeeEpic,
  deleteEmployeeEpic,
  findEmployeesEpic,
  findEmployeeEpic,
  updateEmployeeEpic,
  searchEmployeesEpic,
);
